const newApplication = {
  namespaced: true,
  state: {
    webMemInfo: undefined, // WEB会員情報
    totalFee: 0, // ご請求金額 合計
    paymentMethod: 1, // 決済方法
    offerCode: '' // 申込認証コード
  },
  getters: {
  },
  mutations: {
    setWebMemberInfo(state, webMemInfo) {
      console.log('[store:new-application/setWebMemberInfo]', webMemInfo)
      state.webMemInfo = webMemInfo
    },
    setTotalFee(state, totalFee) {
      console.log('[store:new-application/setTotalFee]', totalFee)
      state.totalFee = totalFee
    },
    setPaymentMethod(state, paymentMethod) {
      console.log('[store:new-application/setPaymentMethod]', paymentMethod)
      state.paymentMethod = Number(paymentMethod)
    },
    setOfferCode(state, offerCode) {
      console.log('[store:new-application/setOfferCode]', offerCode)
      state.offerCode = offerCode
    },
    clearAllStates(state) {
      state.webMemInfo = undefined
      state.totalFee = 0
      state.paymentMethod = 1
      state.offerCode = ''
    }
  },
  actions: {
    setWebMemberInfo({ commit }, webMemInfo) {
      commit('setWebMemberInfo', webMemInfo)
    },
    setTotalFee({ commit }, totalFee) {
      commit('setTotalFee', totalFee)
    },
    setPaymentMethod({ commit }, paymentMethod) {
      commit('setPaymentMethod', paymentMethod)
    },
    setOfferCode({ commit }, offerCode) {
      commit('setOfferCode', offerCode)
    },
    clearAllStates({ commit }) {
      commit('clearAllStates')
    }
  }
}

export default newApplication
